import { NotFound } from "@pages/ui/NotFound";
import type { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFound,
});

function RootComponent() {
  return (
    <div className="mx-auto max-w-md min-h-dvh text-gray-900 md:max-w-none">
      <Outlet />
    </div>
  );
}
